module.exports = __webpack_public_path__ + "static/img/i7.af82a85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet/i7.png
// module id = RxQi
// module chunks = 0